import { fromJS } from 'immutable'
import {
  COMPENSATE_REQUEST_GET_REQUEST,
  COMPENSATE_REQUEST_GET_SUCCESS,
  COMPENSATE_REQUEST_GET_FAILURE,
  COMPENSATE_REQUEST_GET_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPENSATE_REQUEST_GET_REQUEST:
      return state
        .set('isFetching', true)
    case COMPENSATE_REQUEST_GET_SUCCESS:
      return state
        .set('compensateWithMeta', fromJS(action.payload))
        .set('isFetching', false)
    case COMPENSATE_REQUEST_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case COMPENSATE_REQUEST_GET_RESET:
      return state
        .delete('compensateWithMeta')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/compensate-request/compensate-request-get-reducer.js